import { Card, YStack, Text } from 'tamagui'
import { HeroIcon } from '@components/HeroIcon'

interface IEmptyLessonCardProps extends React.ComponentProps<typeof Card> {
  cardPadding: number
  cardWidthStyle: number | string
  cardMinHeightStyle: number | string
}

export function EmptyLessonCard({
  cardPadding,
  cardWidthStyle,
  cardMinHeightStyle,
  ...rest
}: IEmptyLessonCardProps) {
  return (
    <Card
      {...rest}
      bg="$bg-surface"
      padding={cardPadding}
      borderRadius={8}
      maxWidth={cardWidthStyle}
      minWidth={cardWidthStyle}
      minHeight={cardMinHeightStyle}
    >
      <YStack flex={1} alignItems="center" gap={24} justifyContent="center">
        <HeroIcon icon={['fal', 'hourglass']} color="$icon-primary" size={46} />
        <Text
          color="$text-primary"
          ff="$mulishSemiBold"
          fontSize="$font-size-sm"
          whiteSpace="pre-line"
          textAlign="center"
        >
          Em breve esse conteúdo {'\n'}
          será adicionado
        </Text>
      </YStack>
    </Card>
  )
}
